/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.addEventListener('load', () => {
  let toggleItems = document.querySelectorAll('.c-toggle__item');
  if(toggleItems){
    toggleItems.forEach(toggleItem => {
      let toggleHeading = toggleItem.querySelector('.head');
      toggleHeading.addEventListener('click', () => {        
        jQuery(toggleHeading).toggleClass('is-active');
        jQuery(toggleHeading.nextElementSibling).slideToggle();
      })
    })
  }
})

jQuery(function($){
  var speed = 500;

  var hash = document.location.hash.split('#');

  $('a[href^="#"]').on('click', function(){
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - 50;
  
    $('html, body').animate({scrollTop:position}, speed, 'swing');
    window.location.hash = href;
    return false;
  });
});

(function(){
// Get the language from the URL
const lang = window.location.href.includes('/en/') ? 'en' : 'ja';

// Select all elements with the data-translate attribute
const elements = document.querySelectorAll('[data-translate]');

// Loop through each element and replace its text content
elements.forEach(element => {
  // Get the translation for the current language
  const translation = element.getAttribute(`data-translate-${lang}`);

  // Replace the text content with the translation
  element.textContent = translation;
});
})();